export default {"src":"/_next/static/media/scroll.f57690cc.gif","height":800,"width":500,"blurWidth":0,"blurHeight":0};